
import LoleLink from '~/components/link/lole-link'
import LoleBtn from '~/components/buttons/lole-btn'

export default {
  components: {
    LoleLink,
    LoleBtn,
  },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cssProps() {
      let imageDesktop = null
      let imageMobile = null
      if (
        this.blok.header_background_image &&
        this.blok.header_background_image.filename
      )
        imageDesktop = this.blok.header_background_image.filename
      if (
        this.blok.header_background_image_mobile &&
        this.blok.header_background_image_mobile.filename
      )
        imageMobile = this.blok.header_background_image_mobile.filename
      return {
        '--bg-desktop': 'url(' + imageDesktop + ')' || '',

        '--bg-mobile': 'url(' + imageMobile + ')' || '',
      }
    },
    isExternalLink() {
      return !!this.blok.header_button_link.includes('http')
    },
  },
}
